export default {
    title: 'Products',
    headerActions: {
        sortFilters: {
            newest: 'Newest',
            mostOrdered: 'Most Ordered',
            priceLow: 'Price Low to High',
            priceHigh: 'Price High to Low',
        },
        search: 'Search',
        products: 'products',
        filtersMobileButton: 'Filters'
    },
    productItem: {
        notAvailable: 'Not available',
        notDelivering: 'Not delivering',
        ratings: 'ratings',
        button: {
            addToCart: 'Add to cart',
            notify: 'Notify me'
        },
        from: 'from',
        to: 'to'
    },
    sidebar: {
        title: 'Product filter',
        resetAllButton: 'Reset all',
        filter: {
            showAllButton: 'Show all',
            showLessButton: 'Show less',
            categories: {
                title: 'Store Categories',
            },
            manufacturer: {
                title: 'Brand',
                searchPlaceholder: 'Search for a brand',
            },
            price: {
                title: 'Price'
            },
            rating: {
                title: 'Rating'
            },
            currentlyAvailable: {
                title: 'Currently available'
            },
            discounts: {
                title: 'Discounts',
                allDiscounts: 'All discounts',
                andMore: 'and more'
            }
        }
    }
}
